import {
  EditOutlined,
  MessageOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Spacing, SpacingRow, SpacingUnit } from 'components/ui';
import { ActivityKind } from 'entities/TableCellActivity';

import { CommentComponentsCommonProps } from '../types';

import s from './Header.module.scss';
import { Tag, TagChangeEvent } from './Tag';

const Header: React.FC<CommentComponentsCommonProps> = ({ commentsStore }) => {
  const { t } = useTranslation();
  const value = commentsStore.currentEntity?.params.controller.value;

  const handleFilterChange = React.useCallback(
    (params: TagChangeEvent) => {
      if (params.checked) {
        commentsStore.addFilter(params.value);

        return;
      }

      commentsStore.removeFilter(params.value);
    },
    [commentsStore]
  );

  return (
    <Spacing spacing={SpacingUnit.unit3}>
      <div>
        {(typeof value === 'string' || typeof value === 'number') && (
          <Typography.Title level={3}>{value}</Typography.Title>
        )}
        <Typography.Text className={s.header__description} type="secondary">
          {t('comments.employeeComments')}
        </Typography.Text>
      </div>
      <SpacingRow hSpacing={SpacingUnit.unit4}>
        <Typography.Text type="secondary">
          {t('comments.show')}
        </Typography.Text>
        <Tag
          onChange={handleFilterChange}
          checked={commentsStore.filters.includes(ActivityKind.comment)}
          value={ActivityKind.comment}
        >
          <SpacingRow hSpacing={SpacingUnit.unit2}>
            <MessageOutlined />
            {t('comments.activityComments')}
          </SpacingRow>
        </Tag>
        <Tag
          onChange={handleFilterChange}
          checked={commentsStore.filters.includes(ActivityKind.change)}
          value={ActivityKind.change}
        >
          <SpacingRow hSpacing={SpacingUnit.unit2}>
            <EditOutlined />
            {t('comments.activityChanges')}
          </SpacingRow>
        </Tag>
        <Tag
          onChange={handleFilterChange}
          checked={commentsStore.filters.includes(ActivityKind.status_change)}
          value={ActivityKind.status_change}
        >
          <SpacingRow hSpacing={SpacingUnit.unit2}>
            <SyncOutlined />
            {t('comments.activityStatuses')}
          </SpacingRow>
        </Tag>
      </SpacingRow>
    </Spacing>
  );
};

export default observer(Header);
